import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import './HeaderMenu.scss'
import $ from 'jquery'
import jQuery from 'jquery'
import { RoleType } from '../Commons/Utils'
import { Badge } from '../../Containers/Chat/Badge'
import { HeaderMenuProvider } from './HeaderMenu.Context'
class HeaderMenu extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            visible: false,
        }

        this.showMenu = this.showMenu.bind(this)
        this.hideMenu = this.hideMenu.bind(this)
    }

    UNSAFE_componentWillMount() {}

    componentDidMount() {
        $('.menu_hover').mouseover(function() {
            $('.sub_navi, .sub_ul')
                .stop()
                .slideDown('fast')
        })

        $('.bottom_wrap').mouseleave(function() {
            $('.sub_navi, .sub_ul')
                .stop()
                .slideUp('fast')
        })

        $('.menu_hover_m').click(function() {
            $(this)
                .children('.sub_menu')
                .slideDown()
            $('.sub_menu')
                .not($(this).children('.sub_menu'))
                .slideUp()
        })
    }

    showMenu() {
        this.setState({
            visible: true,
        })
    }

    hideMenu() {
        this.setState({
            visible: false,
        })
    }

    render() {
        const appName = this.props.cookies.get('app_name')
        let topLogo = require('../../../Res/img/top_logo.png')
        if (appName && appName !== '') {
            topLogo = require(`../../../Res/3rd/${appName}/img/top_logo.png`)
        }

        return (
            <HeaderMenuProvider channelUrl={this.props.cookies.get('project_chatRoom')}>
                <div className="header_menu">
                    <div className="header_menu_wrap">
                        <div className="top_wrap pc_v" style={{ height: '51px' }}>
                            <div className="common_wrap menu_top_wrap" style={{ lineHeight: '41px', padding: '8px' }}>
                                <h1>
                                    <Link to="/">
                                        <img src={topLogo} alt="HausPlanner" width="166" />
                                    </Link>
                                </h1>
                                {this.props.cookies.get('demo') !== 'true' ? (
                                    <div className="navi">
                                        <Link to="/project">PROJECT</Link>
                                        <div className="line" />
                                        <Link to="/mypage">MY</Link>
                                    </div>
                                ) : (
                                    <div className="navi">
                                        <Link to="/logout">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 14">
                                                <g
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    stroke="#ff0000"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3">
                                                    <path d="M7 13H3.429C2.639 13 2 12.463 2 11.8V2.2C2 1.537 2.64 1 3.429 1H7M11 9.5L13 7l-2-2.5M12.6 7H5.227" />
                                                </g>
                                            </svg>
                                            <font color="#ff0000">메인화면으로 나가기</font>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="bottom_wrap pc_v">
                            <div className="main_navi common_wrap">
                                <ul className="main_ul">
                                    <li className="main_li menu_hover">
                                        <a>
                                            {this.props.cookies.get('project_name')}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="8"
                                                height="6"
                                                viewBox="0 0 8 6">
                                                <path
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    stroke="#24524A"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.2"
                                                    d="M6.998 1.5L3.996 4.522 1 1.5"
                                                />
                                            </svg>
                                        </a>
                                        <ul className="sub_ul sub_ul1">
                                            <li>
                                                <Link to="/intro">계획</Link>
                                            </li>
                                            <li>
                                                <Link to="/intro/detail">도면</Link>
                                            </li>
                                            <li>
                                                <Link to="/intro/complete">완공</Link>
                                            </li>
                                            {this.props.cookies.get('project_scan3dView') === 'true' && (
                                                <li className="main_li">
                                                    <Link to="/intro/scan3d">3D 촬영</Link>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                    {this.props.cookies.get('project_detailReport') === 'true' && (
                                        <li className="main_li">
                                            <Link to="/intro/dashboard">현황판</Link>
                                        </li>
                                    )}
                                    <li className="main_li">
                                        <Link to="/schedule">스케줄</Link>
                                    </li>
                                    <li className="main_li">
                                        <Link to="/report">작업보고</Link>
                                    </li>
                                    <li className="main_li">
                                        <Link to="/demand/">건축주요청</Link>
                                    </li>
                                    <li className="main_li">
                                        <Link to="/todo/">건축주할일</Link>
                                    </li>
                                    <li className="main_li">
                                        <Link to="/meeting/">회의록</Link>
                                    </li>
                                    <li className="main_li">
                                        <Link to="/budget/contracts">계약/청구서</Link>
                                    </li>
                                    {this.props.cookies.get('project_chatOpen') === 'true' && (
                                        <li className="main_li">
                                            <Link
                                                to="/chat"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                채팅 <Badge />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="sub_navi"></div>
                        </div>

                        <div className="bottom_wrap_m mobile_v" style={{ height: '54px' }}>
                            <div
                                className="common_wrap"
                                style={{
                                    height: '54px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                <div className="logo" style={{ marginTop: '16px' }}>
                                    <Link to="/">
                                        <img src={topLogo} alt="HausPlanner" width="166" />
                                    </Link>
                                </div>

                                <div className="menu_btn" onClick={() => this.showMenu()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17">
                                        <path
                                            fill="#000"
                                            fillRule="nonzero"
                                            d="M0 8.309c0-.669.542-1.21 1.21-1.21h13.58a1.21 1.21 0 0 1 0 2.42H1.21A1.21 1.21 0 0 1 0 8.309zm0 7.098c0-.668.542-1.21 1.21-1.21h19.58a1.21 1.21 0 1 1 0 2.42H1.21A1.21 1.21 0 0 1 0 15.407zM0 1.21C0 .542.542 0 1.21 0h19.58a1.21 1.21 0 0 1 0 2.42H1.21A1.21 1.21 0 0 1 0 1.21z"
                                        />
                                    </svg>
                                </div>
                            </div>

                            {/* mobile menu */}
                            <div
                                className={
                                    this.state.visible ? 'menu_show mobile_menu_bg' : 'menu_hide mobile_menu_bg'
                                }>
                                <div className="mobile_menu_wrap">
                                    <div className="close_btn" onClick={() => this.hideMenu()}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#ECEEF3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2.4">
                                                <path d="M18 2L2 18M2 2l16 16" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="top">
                                        {this.props.cookies.get('demo') === 'false' ? (
                                            <Link to="/mypage">
                                                <div className="top_btn">
                                                    MY
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        width="8"
                                                        height="12"
                                                        viewBox="0 0 8 12">
                                                        <defs>
                                                            <path id="arrow1" d="M112 0h208v568H112z" />
                                                            <filter
                                                                id="arrow2"
                                                                width="106.7%"
                                                                height="102.5%"
                                                                x="-4.3%"
                                                                y="-1.2%"
                                                                filterUnits="objectBoundingBox">
                                                                <feOffset
                                                                    dx="-2"
                                                                    in="SourceAlpha"
                                                                    result="shadowOffsetOuter1"
                                                                />
                                                                <feGaussianBlur
                                                                    in="shadowOffsetOuter1"
                                                                    result="shadowBlurOuter1"
                                                                    stdDeviation="2"
                                                                />
                                                                <feColorMatrix
                                                                    in="shadowBlurOuter1"
                                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                                                />
                                                            </filter>
                                                        </defs>
                                                        <g fill="none" fillRule="evenodd">
                                                            <path
                                                                fill="#000"
                                                                fillOpacity=".6"
                                                                d="M-198-24h320v618h-320z"
                                                            />
                                                            <g transform="translate(-198 -24)">
                                                                <use
                                                                    fill="#000"
                                                                    filter="url(#arrow2)"
                                                                    xlinkHref="#arrow1"
                                                                />
                                                                <use fill="#FFF" xlinkHref="#arrow1" />
                                                            </g>
                                                            <path
                                                                stroke="#24524A"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="1.2"
                                                                d="M1.5 1.5l5 4.5-5 4.5"
                                                            />
                                                        </g>
                                                    </svg>
                                                </div>
                                            </Link>
                                        ) : (
                                            <div className="top_btn">GUEST</div>
                                        )}
                                    </div>

                                    <ul className="top_menu">
                                        <li className="menu_hover_m">
                                            {this.props.cookies.get('project_name')}
                                            <ul className="sub_menu">
                                                <li>
                                                    <Link to="/intro/">계획</Link>
                                                </li>
                                                <li>
                                                    <Link to="/intro/detail">도면</Link>
                                                </li>
                                                <li>
                                                    <Link to="/intro/complete">완공</Link>
                                                </li>
                                                {this.props.cookies.get('project_scan3dView') === 'true' && (
                                                    <li className="main_li">
                                                        <Link to="/intro/scan3d">3D 촬영</Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </li>
                                        {this.props.cookies.get('project_detailReport') === 'true' && (
                                            <li>
                                                <Link to="/intro/dashboard">현황판</Link>
                                            </li>
                                        )}
                                        <li>
                                            <Link to="/schedule/">스케줄</Link>
                                        </li>
                                        <li>
                                            <Link to="/report/">작업보고</Link>
                                        </li>
                                        <li>
                                            <Link to="/demand/">건축주요청</Link>
                                        </li>
                                        <li>
                                            <Link to="/todo/">건축주할일</Link>
                                        </li>

                                        <li>
                                            <Link to="/meeting/">회의록</Link>
                                        </li>
                                        <li>
                                            <Link to="/budget/contracts">계약/청구서</Link>
                                        </li>
                                        {this.props.cookies.get('project_chatOpen') === 'true' && (
                                            <li>
                                                <Link
                                                    to="/chat"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}>
                                                    채팅 <Badge />
                                                </Link>
                                            </li>
                                        )}
                                    </ul>

                                    <div className="top_menu_project_selection">
                                        <Link to="/project">
                                            <div className="project_list_btn">
                                                <p>프로젝트 선택</p>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="bottom">
                                        <div className="footer_menu">
                                            {/* <a href="http://www.ai-con.co.kr" target="_blank">
                                            회사소개
                                        </a>
                                        <a href="http://cafe.naver.com/usehands" target="_blank">
                                            네이버 카페
                                        </a> */}
                                            <Link to="/policy/">이용약관</Link>
                                            <Link to="/policy/">개인정보처리방침</Link>
                                        </div>
                                    </div>
                                    {this.props.cookies.get('demo') === 'true' && (
                                        <Link to="/logout">
                                            <div className="logout_btn">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14">
                                                    <g
                                                        fill="none"
                                                        fillRule="evenodd"
                                                        stroke="#ff0000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3">
                                                        <path d="M7 13H3.429C2.639 13 2 12.463 2 11.8V2.2C2 1.537 2.64 1 3.429 1H7M11 9.5L13 7l-2-2.5M12.6 7H5.227" />
                                                    </g>
                                                </svg>
                                                <font color="#ff0000">메인화면으로 나가기</font>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </HeaderMenuProvider>
        )
    }
}

export default withCookies(HeaderMenu)



// WEBPACK FOOTER //
// ./Src/Components/Commons/HeaderMenu.js